import getP13nData from 'services/api/p13n/getP13nData';
import getP13nNbcData from 'services/api/p13n/getP13nNbcData';
import getPreviewP13nData from 'services/api/p13n/getPreviewP13nData';
import getP13nBirthdayData from 'services/api/p13n/getP13nBirthdayData';

export default { getP13nData, getP13nNbcData, getPreviewP13nData, getP13nBirthdayData };
